<template>
  <v-row>
    <v-col cols="4" class="graph left-side">
      <div class="text-h6">
        {{ item.name | displayFormat }}
      </div>
      <span class="record-count pl-2 text--secondary">
        {{ item.count }}
        <span>
          {{ 'similar record' | displayPlural(item.count) }}
        </span>
      </span>
    </v-col>
    <v-col align-self="start">
      <div v-if="item.range">
        <div
          class="bar-container d-flex align-center"
          v-if="hasMultiple(item.range)"
        >
          <span
            v-for="(segment, index) in item.range"
            :key="`segment-${index}`"
            class="graph right-side multi"
            :style="{
              width: getPercent(segment.count, item.count) + '%',
              backgroundColor:
                backgroundColors[index % backgroundColors.length],
            }"
          ></span>
        </div>
        <div class="mt-2">
          <div
            v-for="(subValue, index) in item.range"
            :key="`subItemRange-${index}`"
          >
            <div v-if="hasMultiple(item.range)" class="body-2">
              <div
                class="colorBlock"
                :style="{
                  backgroundColor:
                    backgroundColors[index % backgroundColors.length],
                }"
              ></div>
              {{ getRangeText(subValue, item, true) }}
            </div>
            <div v-else class="mt-n1 font-weight-medium">
              {{ getRangeText(subValue, item, false) }}
            </div>
          </div>
        </div>
      </div>

      <div v-else class="bar-container d-flex align-center">
        <div
          class="font-weight-medium text-capitalize"
          v-if="item.values !== ''"
        >
          {{ item.values }}
        </div>
        <div v-else class="text--disabled">&lt;No value&gt;</div>
      </div>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: 'AnalysisGraphRow',
  data() {
    return {
      // backgroundColors: ['#af4448', '#2286c3', '#519657', '#263238', '#1accbe'],
      backgroundColors: ['#e57373', '#64b5f6', '#81c784', '#263238', '#1accbe'],
    };
  },
  props: {
    recordCount: Number,
    item: Object,
  },
  mounted() {},
  updated() {},
  computed: {},
  methods: {
    getPercent(val, total) {
      let newVal = val;
      if (Array.isArray(val)) {
        newVal = val.reduce((prevVal, currVal) => prevVal + currVal.count, 0);
      }
      return this.returnPercentage(newVal, total);
    },
    returnPercentage(val, total) {
      return this.roundToTwoPlaces(val / total);
    },
    roundToTwoPlaces(val) {
      return Math.round(val * 1000) / 10;
    },
    hasMultiple(item) {
      return item.length > 1;
    },
    getRangeText(subValue, item, showPercent) {
      return `Range: ${subValue.range.min} - ${subValue.range.max}${
        showPercent
          ? ` (${this.getPercent(subValue.count, item.count) + '%'})`
          : ''
      }`;
    },
  },
  filters: {
    displayFormat: function(value) {
      if (!value) return '';
      return value.replace('_', ' ');
    },
    displayPlural: function(text, value) {
      return `${text}${value === 1 ? '' : 's'}`;
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.graph-container {
  margin-left: 4rem;

  .graph {
    display: inline-block;

    &.left-side {
      text-align: right;
      margin-right: 0rem;
      padding-right: 1rem;
      border-right: 1px solid #000;
    }
    &.right-side {
      text-align: right;
      margin-left: 0rem;
      border: 1px solid #000;
      background-color: #4a90e2;
      height: 100%;
    }
  }
  .bar-container {
    height: 32px;
    width: 100%;
  }
  span.right-side.multi {
    border-left: none;

    &:first-of-type {
      border-left: 1px solid #000;
    }
  }
  .colorBlock {
    display: inline-block;
    height: 1rem;
    width: 1rem;
    border: 1px solid #000;
    vertical-align: sub;
  }
  .record-count {
    white-space: nowrap;
  }
}
</style>
